//
//
//
//
//
//
//
//
//
//
//
//
//
//

const sizeClasses = {
  extralarge: 'text-xl',
  large: 'text-lg',
  medium: 'text-base',
  small: 'text-small',
  extrasmall: 'text-xs'
}

export default {
  props: {
    // required
    text: {
      type: String,
      required: true
    },
    // optional
    number: {
      type: Number,
      required: false,
      default: null
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    isExcluded: {
      type: Boolean,
      required: false,
      default: false
    },
    textSize: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  computed: {
    sizeClass() {
      return sizeClasses[this.textSize]
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', {
        text: this.text,
        number: this.number != null ? this.number : null
      })
    }
  }
}
